/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Other16Inputs */

const en__field_enum_csjensblank_other16 = /** @type {(inputs: _Field_Enum_Csjensblank_Other16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const de__field_enum_csjensblank_other16 = /** @type {(inputs: _Field_Enum_Csjensblank_Other16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiger Fachbereich`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {_Field_Enum_Csjensblank_Other16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_other16 = /** @type {((inputs?: _Field_Enum_Csjensblank_Other16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Other16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_other16(inputs)
	return de__field_enum_csjensblank_other16(inputs)
});
export { _field_enum_csjensblank_other16 as "_field_enum_CSJENSBLANK_OTHER" }